module.exports = __webpack_public_path__ + "static/img/SIENA-OAK.6f9b505.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/SIENA-OAK.png
// module id = TLMp
// module chunks = 0